<template>
  <div class="webzineMagazineArticle__container">
    <div class="webzineMagazineArticle__section">
      <div class="webzineMagazineArticle__title">
        <h2 class="heading_title" v-if="categorydata?.categorytitle">
          {{ categorydata?.categorytitle }}
        </h2>
      </div>

      <div class="webzineMagazineArticle__innerContainer">
        <div class="webzineMagazineArticle__leftArticle first">
          <article>
            <a v-hrefsafe="categorydata?.firstArticle?.articleUrl">
              <webzine-magazine-article-media
                :desktop-video-src="
                  categorydata.firstArticle?.mediaBlock.desktopVideo.src
                "
                :mobile-video-src="
                  categorydata.firstArticle?.mediaBlock.mobileVideo.src
                "
                :desktop-img-src="
                  categorydata.firstArticle?.mediaBlock.desktopImage.src
                "
                :mobile-img-src="
                  categorydata.firstArticle?.mediaBlock.mobileImage.src
                "
                :desktop-img-alt="
                  categorydata.firstArticle?.mediaBlock.desktopImage?.alt
                "
              >
              </webzine-magazine-article-media>
              <div class="webzineMagazineArticle__contentOverlay">
                <div
                  class="mainArticleRibbon"
                  v-if="categorydata.firstArticle?.ribbonText"
                >
                  {{ categorydata.firstArticle?.ribbonText }}
                </div>

                <h4
                  class="mainArticleTitle"
                  v-if="categorydata.firstArticle?.title"
                >
                  {{ categorydata.firstArticle?.title }}
                </h4>

                <p v-if="initialdata.readmoretext" class="mainArticleCta" @click="dataLayerPush(categorydata.firstArticle.readMoreTagging)">
                  {{ initialdata.readmoretext }}
                </p>
              </div>
            </a>
          </article>
        </div>

        <div class="webzineMagazineArticle__rightArticle">
          <div class="articleCard-left second">
            <article
              class="articleCard"
              v-for="(item, index) in oddSplitItem"
              :key="'odd-' + index"
            >
              <a v-hrefsafe="item.articleUrl" class="articleCard__link">
                <div class="articleCard__container">
                  <webzine-magazine-article-media
                    :desktop-video-src="item.mediaBlock?.desktopVideo.src"
                    :mobile-video-src="item.mediaBlock?.mobileVideo.src"
                    :desktop-img-src="item.mediaBlock?.desktopImage.src"
                    :mobile-img-src="item.mediaBlock?.mobileImage.src"
                    :desktop-img-alt="item.mediaBlock?.desktopImage?.alt"
                  >
                  </webzine-magazine-article-media>
                </div>

                <div class="articleCard__content">
                  <div class="mainArticleRibbon" v-if="item?.ribbonText">
                    {{ item?.ribbonText }}
                  </div>

                  <h4 class="mainArticleTitle" v-if="item.title">
                    {{ item.title }}
                  </h4>

                  <p v-if="initialdata.readmoretext" class="mainArticleCta" @click="dataLayerPush(item.readMoreTagging)">
                    {{ initialdata?.readmoretext }}
                  </p>
                </div>
              </a>
            </article>
          </div>

          <div class="articleCard-right third">
            <article
              class="articleCard"
              v-for="(item, index) in evenSplitItem"
              :key="'even-' + index"
            >
              <a v-hrefsafe="item.articleUrl" class="articleCard__link">
                <div class="articleCard__container">
                  <webzine-magazine-article-media
                    :desktop-video-src="item.mediaBlock?.desktopVideo.src"
                    :mobile-video-src="item.mediaBlock?.mobileVideo.src"
                    :desktop-img-src="item.mediaBlock?.desktopImage.src"
                    :mobile-img-src="item.mediaBlock?.mobileImage.src"
                    :desktop-img-alt="item.mediaBlock?.desktopImage?.alt"
                  >
                  </webzine-magazine-article-media>
                </div>

                <div class="articleCard__content">
                  <div class="mainArticleRibbon" v-if="item?.ribbonText">
                    {{ item?.ribbonText }}
                  </div>

                  <h4 class="mainArticleTitle" v-if="item.title">
                    {{ item.title }}
                  </h4>

                  <p v-if="initialdata.readmoretext" class="mainArticleCta" @click="dataLayerPush(item.readMoreTagging)">
                    {{ initialdata?.readmoretext }}
                  </p>
                </div>
              </a>
            </article>
          </div>

          <div
            class="articleCard__loadMore"
            v-if="
              this.categorydata.articles?.length >
              this.initialdata?.pageloadcount
            "
          >
            <button
              v-if="hasMore"
              @click="loadMoreCtaClick"
              type="button"
              :class="{
                hideBtn:
                  this.categorydata.articles?.length ===
                  visibleArticles?.length,
              }"
            >
              {{ initialdata?.loadmoretext }}
            </button>
            <a
              v-else-if="showDiscoverMore"
              v-hrefsafe="categorydata.categorypageurl"
              >{{ initialdata.discovermoretext }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import webzineMagazineArticleMedia from './webzine-magazine-article-media.vue';
export default {
  name: 'webzineMagazineArticle',
  components: {
    webzineMagazineArticleMedia,
  },
  props: {
    initialdata: {
      type: [Object, Array],

      required: true,
    },

    categorydata: {
      type: [Object, Array],

      required: true,
    },
  },

  data() {
    return {
      smallScreen: window.matchMedia('(max-width: 1023px)').matches,
      visibleCount: this.initialdata.pageloadcount,
      showDiscovercta: false,
    };
  },
  computed: {
    totalCount() {
      return this.initialdata.totalarticlecount > 0
        ? this.initialdata.totalarticlecount
        : this.categorydata.articles?.length;
    },

    hasMore() {
      return this.visibleArticles?.length < this.totalCount;
    },

    showDiscoverMore() {
      if (this.initialdata.totalarticlecount === 0) return false;

      const allArticlesShown = this.visibleArticles?.length >= this.totalCount;

      return allArticlesShown && !this.hideCta;
    },
    visibleArticles() {
      return this.categorydata.articles?.slice(0, this.visibleCount);
    },
    evenSplitItem() {
      return this.visibleArticles?.filter((_, index) => index % 2 !== 0);
    },
    oddSplitItem() {
      return this.visibleArticles?.filter((_, index) => index % 2 === 0);
    },
  },
  methods: {
    loadMoreCtaClick() {
      const totalCount =
        this.initialdata.totalarticlecount > 0
          ? this.initialdata.totalarticlecount
          : this.categorydata.articles?.length;

      const remaining = totalCount - this.visibleArticles?.length;
      const toAdd = Math.min(this.initialdata.pageloadcount, remaining);
      this.visibleCount += toAdd;
    },
    dataLayerPush(taggingVal) {
      try {
        const eventData = typeof taggingVal === "string" ? JSON.parse(taggingVal) : taggingVal;
        window.dataLayer.push(eventData);
      } catch (error) {
        console.warn('Failed to parse tagging:', error);
      }
    }
  },
};
</script>
<style scoped>
.first,
.second,
.third {
  opacity: 0;
  transform: translateY(15%);
  transition: transform 0.6s ease, opacity 0.6s ease;
}

.translate-in {
  opacity: 1;
  transform: translateY(0%);
}
</style>
